import React, { Fragment } from "react";
import Layout from "../common/layouts";
import { graphql, Link } from "gatsby";
import Seo from "../common/seo";
import { BsSearch, BsListCheck, BsPeople, BsHouse } from "react-icons/bs";
import Pagination from "react-js-pagination";
import "tachyons";
import Select from "react-select";
import queryString from "query-string";

export default class HomeIndex extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      isLoaded: false,
      items: [],
      tenSachChuyenKhao: "",
      tenTacGia: "",
      idTacGia: "",
      itemTacGias: [],
      totalCount: 0,
      pageSize: 10,
      activePage: 1,
      totalSachChuyenKhaos: 0,
    };

    this.handleChangeSachChuyenKhao =
    this.handleChangeSachChuyenKhao.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.getPageUrl = this.getPageUrl.bind(this);
    this.handlePageChange = this.handlePageChange.bind(this);
  }

  getPageUrl(pageNumber) {
    return `/sachchuyenkhao/?page=${pageNumber}`;
  }

  handlePageChange(pageNumber) {
    let url = "";
    if (this.state.tenTacGia.value === undefined) {
      url =
        this.props.data.site.siteMetadata.callApi +
        `/GetSachChuyenKhaos/?idTacGia=00000000-0000-0000-0000-000000000000&tenSach=${this.state.tenSachChuyenKhao}&pageSize=${this.state.pageSize}&pageIndex=${pageNumber}`;
    } else {
      url =
        this.props.data.site.siteMetadata.callApi +
        `/GetSachChuyenKhaos/?idTacGia=${this.state.tenTacGia.value}&tenSach=${this.state.tenSachChuyenKhao}&pageSize=${this.state.pageSize}&pageIndex=${pageNumber}`;
    }

    fetch(url)
      .then((res) => res.json())
      .then(
        (result) => {
          this.setState({
            isLoaded: true,
            items: result.data,
            pageSize: result.pageSize,
            totalCount: result.totalCount,
            activePage: pageNumber,
          });
        },
        (error) => {
          this.setState({
            isLoaded: true,
            error,
          });
        }
      );
  }

  handleChangeSachChuyenKhao(event) {
    this.setState({
      tenSachChuyenKhao: event.target.value,
    });
  }

  handleClick() {
    let url = "";
    if (this.state.tenTacGia.value === undefined) {
      url =
        this.props.data.site.siteMetadata.callApi +
        `/GetSachChuyenKhaos/?idTacGia=00000000-0000-0000-0000-000000000000&tenSach=${this.state.tenSachChuyenKhao}`;
    } else {
      url =
        this.props.data.site.siteMetadata.callApi +
        `/GetSachChuyenKhaos/?idTacGia=${this.state.tenTacGia.value}&tenSach=${this.state.tenSachChuyenKhao}`;
    }
    this.setState((prevState) =>
      fetch(url)
        .then((res) => res.json())
        .then(
          (result) => {
            this.setState({
              isLoaded: true,
              items: result.data,
              pageSize: result.pageSize,
              totalCount: result.totalCount,
              activePage: 1,
            });
          },
          (error) => {
            this.setState({
              isLoaded: true,
              error,
            });
          }
        )
    );
  }

  componentDidMount() {
    const { state } = this.props.location;

    if (this.props.location.search) {
      this.handlePageChange(parseInt(queryString.parse(this.props.location.search).page));
    } else {
      let idTacGia = "00000000-0000-0000-0000-000000000000";
      let tenSachChuyenKhao = "";

      if (state?.privatelKey !== undefined) {
        idTacGia = state.privatelKey;
      } else if (state?.generalKey !== undefined) {
        tenSachChuyenKhao = state?.generalKey;
        this.setState({
          tenSachChuyenKhao: state.generalKey,
        });
      } else if (
        state?.tenSachChuyenKhao_loc !== undefined &&
        state?.idTacGia_loc !== undefined
      ) {
        tenSachChuyenKhao = state?.tenSachChuyenKhao_loc;
        idTacGia = state?.idTacGia_loc;

        this.setState({
          tenSachChuyenKhao: state?.tenSachChuyenKhao_loc,
        });
      } else if (state?.tenSachChuyenKhao_loc !== undefined) {
        tenSachChuyenKhao = state?.tenSachChuyenKhao_loc;
        this.setState({
          tenSachChuyenKhao: state?.tenSachChuyenKhao_loc,
        });
      } else if (state?.idTacGia_loc !== undefined) {
        idTacGia = state?.idTacGia_loc;
      }

      let url =
        this.props.data.site.siteMetadata.callApi +
        `/GetSachChuyenKhaos/?idTacGia=${idTacGia}&tenSach=${tenSachChuyenKhao}`;
      fetch(url)
        .then((res) => res.json())
        .then(
          (result) => {
            this.setState({
              isLoaded: true,
              items: result.data,
              pageSize: result.pageSize,
              totalCount: result.totalCount,
              activePage: 1,
            });
          },
          (error) => {
            this.setState({
              isLoaded: true,
              error,
            });
          }
        );
    }

    fetch(
      this.props.data.site.siteMetadata.callApi + `/GetTotalSachChuyenKhaos`
    )
      .then((res) => res.json())
      .then(
        (result) => {
          this.setState({
            isLoaded: true,
            totalSachChuyenKhaos: result,
          });
        },
        (error) => {
          this.setState({
            isLoaded: true,
            error,
          });
        }
      );

    fetch(this.props.data.site.siteMetadata.callApi + `/GetNhanSuForDanhMucs`)
      .then((res) => res.json())
      .then(
        (result) => {
          if (state?.privatelKey !== undefined) {
            this.setState({
              tenTacGia: result.find((o) => o.value === state.privatelKey),
            });
          }
          if (state?.idTacGia_loc !== undefined) {
            this.setState({
              tenTacGia: result.find((o) => o.value === state?.idTacGia_loc),
            });
          }
          this.setState({
            isLoaded: true,
            itemTacGias: result,
          });
        },
        (error) => {
          this.setState({
            isLoaded: true,
            error,
          });
        }
      );
  }

  render() {
    const {
      items,
      itemTacGias,
      pageSize,
      totalCount,
      activePage,
      isLoaded,
      totalSachChuyenKhaos,
    } = this.state;

    var sachs;

    if (items && items.length > 0) {
      sachs = (
        <Fragment>
          <section className="flex flex-wrap center justify-center mb2">
            <div className="bb">
              {pageSize * (activePage - 1) + 1} -{" "}
              {items.length + pageSize * (activePage - 1)} / {totalCount} KẾT
              QUẢ
            </div>
          </section>

          <section className="flex flex-wrap center justify-center sans-serif">
            {this.state.items.map((item) => (
              <div
                className="pb2 pt2 w-100 mw9 f6"
                style={{ lineHeight: "normal" }}
                key={item.Id}
              >
                <div
                  className="pa2 display dark-gray overflow-x-auto b--red"
                  style={{
                    backgroundColor: "#e6eaf0",
                    borderBottomStyle: "solid",
                  }}
                >
                  <div className="flex flex-wrap justify-around w-100 mw9">
                    <div className="w-100">
                      <p className="ml2">
                        <Link
                          to={"/sachchuyenkhao/detail/?Id=" + item.Id}
                          state={{
                            modal: true,
                            Id: item.Id,
                          }}
                          className="mt0 dark-red f5 link"
                        >
                          {item.TenSach}
                        </Link>
                      </p>
                      <p className="mt0 ml2">
                        <BsHouse className="fl mr2" /> <b>Nhà xuất bản:</b>{" "}
                        {item.NhaXuatBan === null || item.NhaXuatBan === "" ? (
                          <strong className="light-blue normal">
                            Chưa có thông tin
                          </strong>
                        ) : (
                          item.NhaXuatBan
                        )}
                      </p>
                      <p className="mt0 ml2">
                        <BsListCheck className="fl mr2" /> <b>Loại sách:</b>{" "}
                        {item.LoaiGiaoTrinh === null ||
                        item.LoaiGiaoTrinh === "" ? (
                          <strong className="light-blue normal">
                            Chưa có thông tin
                          </strong>
                        ) : (
                          item.LoaiGiaoTrinh
                        )}
                      </p>
                      <p className="mt0 ml2">
                        <BsPeople className="fl mr2" /> <b>Người tham gia:</b>{" "}
                        {item.DanhSachTacGia === null ||
                        item.DanhSachTacGia === "" ? (
                          <strong className="light-blue normal">
                            Chưa có thông tin
                          </strong>
                        ) : (
                          item.DanhSachTacGia
                        )}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </section>

          <section className="flex flex-wrap center tc justify-center">
            <Pagination
              activePage={this.state.activePage}
              itemsCountPerPage={pageSize}
              totalItemsCount={totalCount}
              pageRangeDisplayed={5}
              onChange={this.handlePageChange.bind(this)}
              getPageUrl={this.getPageUrl.bind(this)}
            />
          </section>
        </Fragment>
      );
    } else if (isLoaded === false) {
      sachs = <h2 className="tc">Đang tải...</h2>;
    } else {
      sachs = <h2 className="tc">Không tìm thấy thông tin sách!</h2>;
    }

    return (
      <Layout activeSach="#f2184f">
        <Seo title={"SÁCH PHỤC VỤ ĐÀO TẠO KHÁC"} />
        <div
          style={{
            minHeight: "44rem",
          }}
          className="sans-serif"
        >
          <section
            style={{
              backgroundImage: `url(${this.props.data.site.siteMetadata.imageQnu})`,
              // backgroundColor: "rgb(63 82 111)",
              backgroundPosition: "bottom",
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
              marginTop: "-9px",
            }}
          >
            <div className="flex flex-wrap justify-between-ns justify-center w-100 mw9 center-l">
              <div className="flex flex-column mt4">
                <h2
                  className="near-white tracked mb0 db tc"
                  style={{
                    fontSize: "25px",
                  }}
                >
                  DỮ LIỆU SÁCH PHỤC VỤ ĐÀO TẠO KHÁC
                </h2>
                <h4
                  style={{ color: "#f2184f" }}
                  className="f4 mt2 tc mr-auto-l"
                >
                  {totalSachChuyenKhaos} KẾT QUẢ
                </h4>
              </div>
              <div className="flex flex-column mb4 mt4">
                <div className="pa3 bg-white">
                  <fieldset className="bn">
                    <legend className="fw9 mb2 f5 near-black tc">
                      Tìm kiếm dữ liệu
                    </legend>
                    <div className="mt1">
                      <input
                        onKeyDown={(ev) => {
                          if (ev.key === "Enter") {
                            this.handleClick();
                          }
                        }}
                        type="text"
                        value={this.state.tenSachChuyenKhao}
                        onChange={this.handleChangeSachChuyenKhao}
                        className="pa2 input-reset ba w-100 bg-transparent pointer"
                        placeholder="Tên sách..."
                        style={{ borderRadius: "4px" }}
                      />
                    </div>
                    <div className="mt3">
                      <Select
                        options={itemTacGias}
                        value={this.state.tenTacGia}
                        onChange={(e) => {
                          this.setState({
                            tenTacGia: e,
                          });
                        }}
                        onKeyDown={(ev) => {
                          if (ev.key === "Enter") {
                            this.handleClick();
                          }
                        }}
                        placeholder="Chọn tác giả..."
                      />
                    </div>
                    <div className="mt3">
                      <button
                        onKeyPress={(ev) => {
                          if (ev.key === "Enter") {
                            this.handleClick();
                          }
                        }}
                        type="button"
                        onClick={this.handleClick}
                        className="pa2 ba bg-transparent w-100 pointer"
                        style={{ backgroundColor: "#f2184f", color: "white" }}
                      >
                        <BsSearch /> Tìm kiếm
                      </button>
                    </div>
                  </fieldset>
                </div>
              </div>
            </div>
          </section>

          <div className="flex flex-column tc">
            <h3 className="near-black f4 tracked db">
              DỮ LIỆU SÁCH PHỤC VỤ ĐÀO TẠO KHÁC
            </h3>
          </div>
          {sachs}
        </div>
      </Layout>
    );
  }
}

export const query = graphql`
  query {
    site {
      siteMetadata {
        siteTitle: title
        description
        imageQnu
        imageQnu2
        siteUrl
        callApi
        hostApi
        avatar
      }
    }
  }
`;
